import { THEME_BREAKPOINT_NAMES } from '../enums/breakpoints';

/**
 * @name THEME_BREAKPOINTS
 * @description default breakpoints
 */
export const THEME_BREAKPOINTS = {
  [THEME_BREAKPOINT_NAMES.LG]: 1224,
  [THEME_BREAKPOINT_NAMES.SM]: 768,
  [THEME_BREAKPOINT_NAMES.XS]: 360,
};
